module.exports = __webpack_public_path__ + "static/media/YF71_0.19b2f41d.jpg";